<div class="grid-6 copo-container footer-margin" *ngIf="batchData">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.metal.unit.information</span>
					<div class="pill metal-unit-status" [class.complete-flag]="isComplete(batchData)"
						[class.incomplete-flag]="isInComplete(batchData)">
						<span class="metal-unit-status-label">{{batchData.completeFlag === 'O' ? ('aqdb.flag.complete' | translate) : ('aqdb.flag.incomplete' | translate)}}</span>
					</div>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block triple-column">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.batch.reference</div>
						<div class="card-content-value">{{ batchData.batchReference ? batchData.batchReference : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.customer.article.ref</div>
						<div class="card-content-value">{{ batchData.articleReference ? batchData.articleReference : UNDERSCORE }}</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.recipient</div>
						<div class="card-content-value">{{ batchData.recipientLabel ? batchData.recipientLabel : UNDERSCORE }}</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.grade</div>
						<div class="card-content-value">{{ batchData.commercialQualityLabel ? batchData.commercialQualityLabel: UNDERSCORE }}
						</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.serial.number</div>
						<div class="card-content-value">{{ batchData.serialNumber ? batchData.serialNumber: UNDERSCORE }}
						</div>
					</div>
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.marked.identity</div>
						<div class="card-content-value">{{ getMinSegmentMarkedIdentity(batchData) || UNDERSCORE }}</div>
					</div>
				</div>
			</div>
		</mat-expansion-panel>
	</div>
</div>
<div class="grid-6 copo-container footer-margin" *ngIf="batchData">
	<div class="grid-column-one-full">
		<mat-expansion-panel [expanded]="true" class="card-info-block">
			<mat-expansion-panel-header>
				<mat-panel-title class="card-content-title">
					<span translate>aqdb.dimensions.form</span>
				</mat-panel-title>
			</mat-expansion-panel-header>
			<mat-divider class="margin-expansion-panel"></mat-divider>
			<div class="card-content-block triple-column">
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.form</div>
						<div class="card-content-value">
							<ng-container [ngSwitch]="batchData.form">
								<span *ngSwitchCase="SLAB_VALUE" translate>form.slab</span>
								<span *ngSwitchCase="BLANKS_VALUE" translate>form.blanks</span>
								<span *ngSwitchCase="COIL_VALUE" translate>form.coil</span>
								<span *ngSwitchCase="HEAVY_PLATE_VALUE" translate>form.heavy.plate</span>
								<span *ngSwitchCase="MIXED_COIL_VALUE" translate>form.mixed.coil</span>
								<span *ngSwitchCase="SCROLLED_SHEET_VALUE" translate>form.scrolled.sheet</span>
								<span *ngSwitchCase="SHEET_VALUE" translate>form.sheet</span>
								<span *ngSwitchCase="SLIT_COIL_VALUE" translate>form.slit.coil</span>
								<span *ngSwitchCase="THICK_PLATE_VALUE" translate>form.thick.plate</span>
								<span *ngSwitchCase="WELDED_COIL_VALUE" translate>form.welded.coil</span>
								<ng-container *ngSwitchDefault>{{ UNDERSCORE }}</ng-container>
							</ng-container>
						</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.format.actual</div>
							<div class="card-content-value">
								{{{ thickness: batchData.realThickness, width: batchData.realWidth} | copoDimension }} / {{{ thickness: batchData.nominalThickness, width: batchData.nominalWidth} | copoDimension }}
						</div>
					</div>
				</div>
				<div class="card-contents-infos">
					<div class="card-content-info">
						<div class="card-content-label" translate>aqdb.weight.mu</div>
						<div class="card-content-value">{{ batchData.qtyBatchGross && batchData.qtyBatchNet
							? ((batchData.qtyBatchNet | copoNumber:'weight') + ' / ' + (batchData.qtyBatchGross | copoNumber:'weight'))
							: UNDERSCORE }}
						</div>
					</div>
				</div>

			</div>
		</mat-expansion-panel>
	</div>
</div>